const tickIconUrl = hcpData.root_url + "/wp-content/themes/jupiter-child-hcp/assets/images/icons/tick.png";
const crossIconUrl = hcpData.root_url + "/wp-content/themes/jupiter-child-hcp/assets/images/icons/cross.png";
const labTestIconUrl = hcpData.root_url + "/wp-content/themes/jupiter-child-hcp/assets/images/icons/lab_test.png";

import copy from '../modules/translations.json';
import { isMailLink } from '../modules/utils';

const getLabCardTemplate = (item, region) => {
 

  const { 
    id, title = '', 
    molecular_testing_available,
    molecular_testing_info = '', // TODO check if deprecated
    enzyme_analysis_available,
    enzyme_analysis_info = '', // TODO check if deprecated
    genes_included_info = '', enzymes_included_info = '', // TODO new fields for popup text, check with UI
    inclusion_criteria_available, inclusion_criteria = '',
    address = '', web = '', email_1 = '', email_2 = '', email_3 = '', phone = ''
  } = item;
  return (`
    <div id="lab${id}" class="lab-item">
      <div class="lab-item__header">
        <div class="lab-item__header-title">${title}</div>
      </div>
      <div class="lab-item__features-container">
        <div class="lab-item__features">
          <div id="popupcontainer_molecularTesting${id}" class="lab-item__feature popupcontainer ${molecular_testing_available ? '' : 'lab-item__feature--disabled'}">
            <img class="lab-item__feature-icon" src="${molecular_testing_available ? tickIconUrl : crossIconUrl}" aria-hidden="true"></img>
            <div class="lab-item__feature-title">${copy.feature_genetic_molecular_testing}</div>
            <div class="popuptext popuptext--left ${molecular_testing_available ? '' : 'hidden'}">
              <div class="popuptext__content-title">${copy.feature_genetic_molecular_testing}</div>
              <div class="popuptext__content">
                ${genes_included_info}
              </div>
              <div class="popuptext__content-close">
                <a class="cln2btn">${copy.feature_popup_close}</a>
              </div>
            </div>
          </div>
          <div id="popupcontainer_enzymeAnalysis${id}" class="lab-item__feature popupcontainer ${enzyme_analysis_available ? '' : 'lab-item__feature--disabled'}">
            <img class="lab-item__feature-icon" src="${enzyme_analysis_available ? tickIconUrl : crossIconUrl}" aria-hidden="true"></img>
            <div class="lab-item__feature-title">${copy.feature_enzyme_activity_analysis}</div>
            <div class="popuptext popuptext--left ${enzyme_analysis_available ? '' : 'hidden'}">
              <div class="popuptext__content-title">${copy.feature_enzyme_activity_analysis}</div>
              <div class="popuptext__content">
                ${enzymes_included_info}
              </div>
              <div class="popuptext__content-close">
                <a class="cln2btn">${copy.feature_popup_close}</a>
              </div>
            </div>
          </div>
          <div id="popupcontainer_inclusionCriteria${id}" class="lab-item__feature popupcontainer ${inclusion_criteria_available ? '' : 'lab-item__feature--disabled'}">
            <img class="lab-item__feature-icon" src="${inclusion_criteria_available ? tickIconUrl : crossIconUrl}" aria-hidden="true"></img>
            ${copy.feature_inclusion_criteria}
            <div class="popuptext popuptext--right">
              <div class="popuptext__content-title">${copy.feature_inclusion_criteria}</div>
              <div class="popuptext__content">
                ${inclusion_criteria} 
              </div>
              <div class="popuptext__content-close">
                <a class="cln2btn">${copy.feature_popup_close}</a>
              </div>
            </div>
          </div>
        </div>
        
      </div>

      <div class="lab-info__contact">

      ${phone || (email_1 || email_2 || email_3) ?
        `
        <div class="lab-info__contact-section lab-info__contact-section--phone-or-mail">

          ${ phone ?`
          <div class="lab-info__contact-item">
            <div class="lab-info__contact-icon">
              <i class="fa fa-phone fa-flip-horizontal" aria-hidden="true"></i>
            </div>
            <div class="lab-info__contact-value">${phone}</div> 
          </div>
          `: ''}

          ${ email_1 || email_2 || email_3 ?`
          <div class="lab-info__contact-item">
            <div class="lab-info__contact-icon">
              <i class="fa fa-envelope" aria-hidden="true"></i>
            </div>
            <div class="lab-info__contact-values">
              ${ email_1 ?`
                <div class="lab-info__contact-value">
                  <a class="lab-info__contact-value--link" href="mailto:${email_1}">${email_1}</a>
                </div>   
              `: ''}
              ${ email_2 ?`
                <div class="lab-info__contact-value">
                  <a class="lab-info__contact-value--link" href="mailto:${email_2}">${email_2}</a>
                </div>
              `: ''}
              ${ email_3 ?`
              <div class="lab-info__contact-value">
                <a class="lab-info__contact-value--link" href="mailto:${email_3}">${email_3}</a>
              </div>
            `: ''}

            </div>
            `: ''}

          </div>
        </div>
        `
      : '' }


      ${web ?
        `
        <div class="lab-info__contact-section">

        <div class="lab-info__contact-item lab-info__contact-item--order-test">
          <a class="lab-info__contact-value--link" href="${isMailLink(web) ? 'mailto:'+ web : web}" target="_blank" 
            onclick="dataLayer.push({
              'event': 'OrderTest',
              'eventCategory' : 'Order a Test',
              'eventAction': 'Click-Order A Test ',
              'eventLabel' : '${web}'
              })
            "
          >
            <button class="cln2btn cln2btn--order-test">
              <img 
                class="cln2btn--icon-before" 
                src="${labTestIconUrl}"
                alt=""
              > 
              ${copy.order_test}
            </button>
          </a>
        </div>

        </div>`
        : '' }
      </div> 
    </div>
  `);
};
          
export {getLabCardTemplate};